import styled from "styled-components";

const KidsHeroWrap = styled.div`
  //background-color: #f4e1ff;
  // background-color: #fff;
  padding: 32px 0;
  text-align: center;
  h4 {
    margin-top: -8px;
    font-size: 45px;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 12px;
  },
  h1 {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1.3;
  }
`

export default KidsHeroWrap